import { render, staticRenderFns } from "./MedicalCertificateRequirement.vue?vue&type=template&id=1833aba7&scoped=true"
import script from "./MedicalCertificateRequirement.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificateRequirement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833aba7",
  null
  
)

export default component.exports